module.exports = __webpack_public_path__ + "account/assets/dzen.f4e8d06c.svg";